var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFavicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 44,
    viewBox: "0 0 43 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6078 2.06342e-10C12.3465 0.000206765 4.80216 4.69204 1.14872 12.1016C0.44664 13.8117 0.0625852 15.4698 0.00718902 16.9863C-0.324814 26.0753 10.9097 25.1908 19.7951 18.2394H9.86882L11.18 11.4934H26.518H33.3906L32.0795 18.2394L29.1708 33.2036H22.2975L24.1592 23.6288C21.7854 27.2856 13.3388 33.9996 2.03658 32.9144C5.96505 39.4183 13.0096 43.3932 20.6078 43.3933C32.5905 43.3934 42.3045 33.6794 42.3044 21.6967C42.3045 9.71392 32.5905 -5.1691e-05 20.6078 2.06342e-10Z",
    fill: "#10b981"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavicon);
export default __webpack_public_path__ + "static/media/favicon.c1f5621367b9fafe1d3123c2df1bcecb.svg";
export { ForwardRef as ReactComponent };